import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientModel } from 'src/app/model/common/patient';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { CommonPersonModel } from 'src/app/model/common/person';
import { PersonService } from '../../person/person.service';
import { PATIENT } from '../patient.constants';
import { PatientService } from '../patient.service';

@Component({
  selector: 'ms-common-patient-dialog',
  templateUrl: './patient-dialog.component.html',
})
export class PatientDialogComponent extends BaseComponent {
  readonly screen = PATIENT;
  patient: CommonPatientModel = {};
  person: CommonPersonModel = {};

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: PatientService,
    protected personService: PersonService
  ) {
    super();
  }

  onInit = () => {
    const { patientData } = this.service.readStore();
    const { personData } = this.personService.readStore();
    this.subscriptions.push(
      patientData.subscribe(
        (result) => (this.patient = this.service.setPatientInformation(result))
      ),
      personData.subscribe((result) => {
        this.person = this.personService.setPersonInformation(result);
        if (this.person.id) {
          this.subscriptions.push(
            this.service.getPatientByPerson(result.id!).subscribe()
          );
        }
      })
    );
  };

  save = () => {
    this.service.setLoadingState();
    const patient = {
      ...this.patient,
      personHelp: this.person,
    };
    delete patient.personHelp.emailHelp;
    delete patient.personHelp.phoneHelp;
    this.config.data.save(patient).subscribe((result: CommonPatientViewModel) =>
      this.ref.close({
        ...result,
        isNew: patient.isNew,
      })
    );
  };
}
